import script from "./AppearanceBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppearanceBlock.vue?vue&type=script&setup=true&lang=ts"

import "./AppearanceBlock.vue?vue&type=style&index=0&id=f8a505f2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8a505f2"]])

export default __exports__